import React, { Component } from 'react';
import Form from "../../components/form/Form";
import { Button, Container, FormGroup, Input, Label } from 'reactstrap';
import { Redirect } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FormattedMessage, injectIntl } from "react-intl";
import PasswordResetRequestModal from "../../components/portfolio/PasswordResetRequestModal";
import Picture from '../../components/Picture'
import { handleRequestError, Request } from '../../helpers/request'
import { withAuth } from '../../helpers/auth'

class LoginPage extends Component
{
    state = {
        email: '',
        password: '',
        modal: false,
    };

    submit = () => {
        const { email, password } = this.state;

        Request.post('login', { email, password })
            .then(data => {
                this.props.auth.setToken(data.api_token)
            })
            .catch(handleRequestError)
    };

    render() {
        const { intl } = this.props;
        const {email, password} = this.state;

        // if (this.props.auth.user && this.props.location && this.props.location.state && this.props.location.state.from)
        //     return (
        //         <Redirect push to={this.props.location.state.from.pathname}/>
        //     );

        if (this.props.auth.user)
            return (
                <Redirect push  to={{
                    pathname: '/myurban',
                    state: { from: this.props.location }
                }} />
            );

        return (
            <div className="login-page">
                <section className="connect-form">
                    <Container>
                        <div className="connect-form-wrap">
                            <Form action={this.submit}>
                                <div className="urban-logo">
                                    <Picture
                                        src={require("../../../images/my-urban.png")}
                                        webp={require("../../../images/my-urban.webp")}
                                        alt="My Urban" />
                                </div>
                                <h2>
                                    <FormattedMessage
                                        id="portfolio.login.subtitle"
                                        defaultMessage="Connectez-vous à votre plateforme Urban Linker"
                                    />
                                </h2>
                                <div className="fields-row">
                                    <FormGroup>
                                        <Label for={'email'}>
                                            <FormattedMessage
                                                id="portfolio.login.email.label"
                                                defaultMessage="Email"
                                            />
                                        </Label>
                                        <Input
                                            id={'email'}
                                            type={'text'}
                                            value={email}
                                            onChange={e => this.setState({ email: e.target.value })}
                                            placeholder={
                                                intl.formatMessage({
                                                    id: "portfolio.login.email.placeholder",
                                                    defaultMessage: "Votre adresse e-mail professionnelle"
                                                })
                                            }
                                            className="input-field"
                                        />
                                    </FormGroup>

                                    <FormGroup>
                                        <Label for={'password'}>
                                            <FormattedMessage
                                                id="portfolio.login.password.label"
                                                defaultMessage="Mot de passe"
                                            />
                                        </Label>
                                        <Input
                                            type="password"
                                            id={'password'}
                                            value={password}
                                            onChange={e => this.setState({ password: e.target.value })}
                                            className="input-field"
                                            placeholder={
                                                intl.formatMessage({
                                                    id: "portfolio.login.password.placeholder",
                                                    defaultMessage: "Votre mot de passe"
                                                })
                                            }
                                        />
                                    </FormGroup>
                                </div>

                                <div className="btn-wrap">
                                    <span className="forget-pwd" onClick={() => this.setState({ modal: true })}>
                                        <FormattedMessage
                                            id="portfolio.login.reset_password"
                                            defaultMessage="J’ai oublié mon mot de passe"
                                        />
                                    </span>
                                    <Button className={'btn btn-danger'}>
                                        <FormattedMessage
                                            id="portfolio.login.button"
                                            defaultMessage="Se connecter"
                                        />
                                    </Button>
                                    <a className="back-btn" onClick={this.props.history.goBack}>
                                        <FontAwesomeIcon icon={faArrowLeft} className={'icon'}/>
                                        <FormattedMessage
                                            id="portfolio.login.back"
                                            defaultMessage="Revenir sur le site"
                                        />
                                    </a>
                                </div>
                            </Form>
                        </div>
                        <PasswordResetRequestModal
                            isOpen={this.state.modal}
                            close={() => this.setState({ modal: false })}
                        />
                    </Container>
                </section>
            </div>
        );
    }
}

export default injectIntl(withAuth(LoginPage));
